import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Logo from './logo';
import { observer } from 'mobx-react';
import { CSSTransitionGroup } from 'react-transition-group';

@observer
export default class LoadingIndicator extends Component {
    constructor(props) {
        super(props);
    }

    renderIndicator() {
        return this.props.isLoading ? <Logo width={30} height={30} className="loadingindicator affix-top" /> : null;
    }

    render() {
        return (
            <CSSTransitionGroup
                transitionName="loadingindicator"
                transitionAppear={true}
                transitionAppearTimeout={500}
                transitionEnterTimeout={500}
                transitionLeaveTimeout={300}
            >
                {this.renderIndicator()}
            </CSSTransitionGroup>
        );
    }
}

LoadingIndicator.propTypes = {
    isLoading: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/shared/loading-indicator.js